import React, { useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
} from "react-router-dom";
import { UserContext } from './providers/UserProvider.js';
import Events from "./Events";
import Login from "./Login.js";
import Artists from "./Artists.js";
import Locations from "./Locations.js";
import Upcoming from "./Upcoming.js";
import Updates from "./Updates.js"; 
import Organizers from "./Organizers.js";
import LinkStickerOverview from "./LinkStickerOverview.js";
import EmailSettings from "./EmailSettings.js";
import AccountSettings from "./AccountSettings.js";

export default function App() {
  const { loaded, user } = useContext(UserContext);

  return loaded ? user ? <Router>
    <div className="h-full overflow-x-hidden">
      <Switch>
        <Route path="/artists" component={Artists} />
        <Route path="/events" component={Events} />
        <Route path="/link-sticker" component={LinkStickerOverview} />
        <Route path="/locations" component={Locations} />
        <Route path="/organizers" component={Organizers} />
        <Route path="/settings/account" component={AccountSettings} />
        <Route path="/settings/emails" component={EmailSettings} />
        <Route path="/upcoming" component={Upcoming} />
        <Route path="/updates" component={Updates} />
        <Route path="/">
          <Redirect to="/events" />
        </Route>
      </Switch>
    </div>
  </Router> : <Login /> : <div className="p-3">Bitte warten...</div>;
}